import { createAction, props } from '@ngrx/store';

export const loadVehicles = createAction('[Global Vehicles State] Load Vehicles', props<any>());

export const reloadVehicles = createAction('[Global Vehicles State] Reload Vehicles', props<any>());

export const loadVehiclesSuccess = createAction(
	'[Global Vehicles State] Vehicles Loaded Success',
	props<any>()
);
